<div
  class="load__header-info"
  [ngClass]="{
    'label-column': hasLabel,
    'speed-up-info-column': hasSpeedUpInfo,
    'region-column': hasRegion,
    'no-label-column': !hasLabel,
    'no-speed-up-info-column': !hasSpeedUpInfo,
    'no-region-column': !hasRegion
  }"
>
  <ng-container *ngIf="hasLabel">
    <ng-container *ngIf="load.isCancelled; else deviationTypeLabel">
      <span class="cancelled-label">{{ 'common.field.cancelled' | translate }} </span>
    </ng-container>
  </ng-container>

  <ng-template #deviationTypeLabel>
    <div>
      <span
        *ngIf="load?.inTime === deviationType.Delay || load?.inTime === deviationType.Early"
        [ngClass]="load?.inTime === deviationType.Delay ? 'delay-label' : 'early-label'"
      >
        {{ 'common.field.' + (load?.inTime | lowercase) | translate }}
      </span>
    </div>
  </ng-template>
  <div *ngIf="hasRegion" class="load__region">
    <ng-container *ngIf="load.origin !== origin.TMSEurolog">
      <ui-svg-icon [name]="iconNameList.Globe"></ui-svg-icon>
      <span cropText>{{ load.region | region }}</span>
    </ng-container>
  </div>

  <div class="load__transport-mode">
    <ui-transport-mode [mode]="load?.transportMode" [showText]="false"></ui-transport-mode>
  </div>

  <div class="load__status" cropText>
    <ui-status-code
      [statusCode]="loadStatus?.statusCode"
      [statusDescription]="loadStatus?.statusDescription"
    ></ui-status-code>
  </div>

  <div class="load__carrier">
    <ui-svg-icon [name]="iconNameList.SteeringWheel"></ui-svg-icon>
    <span cropText>{{ load.carrierName ? load.carrierName : load.carrierId }}</span>
  </div>
  <div *ngIf="load.speedUpInformation">
    <ui-svg-icon [name]="iconNameList.SpeedometerSpeedHigh"></ui-svg-icon>
  </div>
</div>
